<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="sa">
                        <section class="sa-hero">
                            <div class="sa-hero-titulos">
                                <h1 class="sa-hero-titulo">Minhas trilhas</h1>
                                <p class="sa-hero-sub">Retome conteúdos em andamento e acompanhe seu progresso.</p>
                            </div>
                            <div class="sa-hero-lado">
                                <dl class="sa-stats">
                                    <div class="sa-stat">
                                        <dt>Seguindo</dt>
                                        <dd>{{ resumo.seguindo }}</dd>
                                    </div>
                                    <div class="sa-stat">
                                        <dt>Em andamento</dt>
                                        <dd>{{ resumo.andamento }}</dd>
                                    </div>
                                    <div class="sa-stat">
                                        <dt>Concluídas</dt>
                                        <dd>{{ resumo.concluidas }}</dd>
                                    </div>
                                    <div class="sa-stat sa-stat--largo">
                                        <dt>Progresso médio</dt>
                                        <dd class="sa-stat-media">
                                            <span>{{ resumo.media }}%</span>
                                            <span class="sa-stat-barra" role="progressbar" :aria-valuenow="resumo.media" aria-valuemin="0" aria-valuemax="100">
                                                <span :style="{ width: resumo.media + '%' }"></span>
                                            </span>
                                        </dd>
                                    </div>
                                </dl>
                                <router-link :to="{ name: 'SollAcademyTrilhas' }" class="sa-btn sa-btn--primario sa-btn--alto">
                                    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                                    Explorar trilhas
                                </router-link>
                            </div>
                        </section>

                        <main class="sa-main">
                            <div class="sa-toolbar">
                                <div class="sa-segmentos" role="tablist" aria-label="Filtrar por status">
                                    <button v-for="f in filtros"
                                            :key="f.id"
                                            type="button"
                                            role="tab"
                                            class="sa-segmento"
                                            :class="{ 'is-ativo': filtro === f.id }"
                                            :aria-selected="filtro === f.id"
                                            @click="filtro = f.id">
                                        {{ f.label }}
                                        <span class="sa-segmento-num">{{ f.count }}</span>
                                    </button>
                                </div>
                                <div class="sa-toolbar-direita">
                                    <label class="sa-busca">
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                                        <span class="sa-sr">Buscar nas minhas trilhas</span>
                                        <input v-model="busca" type="search" placeholder="Buscar nas minhas trilhas" />
                                    </label>
                                    <label class="sa-ordem">
                                        Ordenar
                                        <select v-model="ordem">
                                            <option value="acesso">Último acesso</option>
                                            <option value="progresso">Maior progresso</option>
                                            <option value="nome">Nome (A–Z)</option>
                                        </select>
                                    </label>
                                </div>
                            </div>

                            <section v-if="retomar" class="sa-painel" aria-labelledby="sa-h-retome">
                                <div class="sa-painel-cabecalho">
                                    <h2 id="sa-h-retome" class="sa-h2">Continue de onde parou</h2>
                                    <span v-if="retomar.ultimoAcesso" class="sa-muted sa-sm">{{ tempoDesde(retomar.ultimoAcesso) }}</span>
                                </div>
                                <button type="button" class="sa-retome" @click="continuar(retomar)">
                                    <span class="sa-retome-capa" :style="tom(retomar)">
                                        <img v-if="!semImagem(retomar)" :src="retomar.urlFoto" alt="" @error="onErroImagem(retomar)" />
                                        <span class="sa-retome-play"><svg viewBox="0 0 24 24" aria-hidden="true" class="is-fill"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5Z" /></svg></span>
                                    </span>
                                    <span class="sa-retome-texto">
                                        <span class="sa-retome-cat">{{ retomar.cat.titulo }}</span>
                                        <span class="sa-retome-titulo">{{ retomar.titulo }}</span>
                                        <span class="sa-retome-progresso">
                                            <span class="sa-barra sa-barra--lg"><span :style="{ width: retomar.pct + '%' }"></span></span>
                                            <span>{{ rotuloAulas(retomar) }}</span>
                                        </span>
                                    </span>
                                    <span class="sa-btn sa-btn--primario sa-btn--alto" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" class="is-fill sa-icone-sm"><path d="M7 4v16l13-8Z" /></svg>
                                        Continuar
                                    </span>
                                </button>
                            </section>

                            <section v-for="g in grupos"
                                     :key="g.id"
                                     class="sa-painel"
                                     :aria-labelledby="'sa-h-cat-' + g.id">
                                <div class="sa-painel-cabecalho">
                                    <div class="sa-painel-titulos">
                                        <h2 :id="'sa-h-cat-' + g.id" class="sa-h2">{{ g.titulo }}</h2>
                                        <span class="sa-muted sa-sm">{{ plural(g.trilhas.length, 'trilha', 'trilhas') }}</span>
                                    </div>
                                    <router-link v-if="g.id !== '_'" class="sa-link" :to="{ name: 'SollAcademyTrilhas', query: { categoria: g.id } }">
                                        Ver categoria
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                    </router-link>
                                </div>
                                <ul class="sa-grade">
                                    <li v-for="t in g.trilhas" :key="t.id">
                                        <button type="button" class="sa-card" @click="clicarCard(t)">
                                            <span class="sa-capa" :style="tom(t)">
                                                <img v-if="!semImagem(t)" :src="t.urlFoto" alt="" @error="onErroImagem(t)" />
                                                <svg v-else class="sa-capa-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 4h7a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H2Z" /><path d="M22 4h-7a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h8Z" /></svg>
                                                <span class="sa-status" :class="statusInfo(t.status).classe">{{ statusInfo(t.status).rotulo }}</span>
                                            </span>
                                            <span class="sa-card-corpo">
                                                <span class="sa-card-titulo">{{ t.titulo }}</span>
                                                <span v-if="t.autor" class="sa-muted sa-sm">{{ t.autor }}</span>
                                                <span class="sa-card-rodape">
                                                    <span class="sa-barra"><span :style="{ width: t.pct + '%' }"></span></span>
                                                    <span class="sa-card-linha">
                                                        <span>{{ rotuloAulas(t) }}</span>
                                                        <span v-if="t.status === 'andamento'"
                                                              class="sa-card-cta is-acao"
                                                              role="link"
                                                              @click.stop="continuar(t)">Continuar</span>
                                                        <span v-else class="sa-card-cta" :class="{ 'is-inativo': !t.total }">{{ statusInfo(t.status).cta }}</span>
                                                    </span>
                                                </span>
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </section>

                            <div v-if="vazio" class="sa-painel sa-vazio">
                                <span class="sa-vazio-icone">
                                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z" /><path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3" /></svg>
                                </span>
                                <strong>{{ vazio[0] }}</strong>
                                <span>{{ vazio[1] }}</span>
                                <button v-if="filtro !== 'todas' || busca" type="button" class="sa-btn sa-btn--contorno" @click="limparFiltros">
                                    Ver todas as minhas trilhas
                                </button>
                                <router-link v-else :to="{ name: 'SollAcademyTrilhas' }" class="sa-btn sa-btn--primario">Explorar trilhas</router-link>
                            </div>
                        </main>

                        <footer class="sa-rodape">
                            <div class="sa-rodape-cta">
                                <div class="sa-rodape-texto">
                                    <strong>Procurando algo novo?</strong>
                                    <span>Explore as categorias e siga novas trilhas para continuar aprendendo.</span>
                                </div>
                                <router-link :to="{ name: 'SollAcademyTrilhas' }" class="sa-btn sa-btn--branco">Explorar categorias</router-link>
                            </div>
                            <div class="sa-rodape-linha">
                                <span>Soll Academy · SollAi</span>
                                <span>Dúvidas? Fale com nossa equipe</span>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

                <ModalTrilha :trilhaSelecionada="trilhaSelecionada"
                     @fechar="trilhaSelecionada = null"
                     @deixouDeSeguir="onDeixouDeSeguir" />
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import ModalTrilha from '@/components/SollAcademy/ModalTrilha.vue'
    import axios from 'axios'
    import { urlApi, avisoToast } from '@/config/global'

    const STATUS = {
        andamento: { rotulo: 'Em andamento', classe: 'is-andamento', cta: 'Continuar' },
        concluidas: { rotulo: 'Concluída', classe: 'is-concluida', cta: 'Rever' },
        nao: { rotulo: 'Não iniciada', classe: 'is-nao', cta: 'Começar' },
    }

    const MENSAGENS_VAZIO = {
        todas: ['Você ainda não segue nenhuma trilha', 'Explore as categorias e siga trilhas para acompanhar seu progresso.'],
        andamento: ['Nenhuma trilha em andamento', 'Comece uma das trilhas que você segue para vê-la aqui.'],
        nao: ['Todas as trilhas já foram iniciadas', 'Bom ritmo! Continue as que estão em andamento.'],
        concluidas: ['Nenhuma trilha concluída ainda', 'Quando você terminar todas as aulas de uma trilha, ela aparece aqui.'],
    }

    export default {
        components: { Header, ModalTrilha },
        name: 'SollAcademyMinhasTrilhas',
        data() {
            return {
                minhasTrilhas: [],
                categorias: [],
                progressos: [],
                currentPage: 0,
                pageSize: 100,
                trilhaSelecionada: null,
                filtro: 'todas',
                busca: '',
                ordem: 'acesso',
                imagensComErro: new Set(),
            }
        },

        computed: {
            progressosUnicos() {
                const best = new Map()
                for (const p of this.progressos || []) {
                    const id = p?.treinamento?.idTreinamento
                    if (!id) continue
                    const atual = best.get(id)
                    if (!atual) { best.set(id, p); continue }
                    const pa = Number(atual.porcentagemCompleta) || 0
                    const pb = Number(p.porcentagemCompleta) || 0
                    if (pb > pa) { best.set(id, p); continue }
                    if (pb === pa) {
                        const da = atual.ultimoProgresso ? new Date(atual.ultimoProgresso).getTime() : -Infinity
                        const db = p.ultimoProgresso ? new Date(p.ultimoProgresso).getTime() : -Infinity
                        if (db > da) best.set(id, p)
                    }
                }
                return Array.from(best.values())
            },

            progressoPorTreinamento() {
                const map = {}
                this.progressosUnicos.forEach(p => {
                    map[p.treinamento.idTreinamento] = {
                        total: Number(p.totalRecursos) || 0,
                        completos: Number(p.recursosCompletos) || 0,
                        percentual: Number(p.porcentagemCompleta) || 0,
                        ultimo: p.ultimoProgresso || null,
                    }
                })
                return map
            },

            lista() {
                return (this.minhasTrilhas || []).map(t => {
                    const prog = this.progressoPorTreinamento[t.idTreinamento]
                    const total = prog?.total || 0
                    const feitas = total ? Math.min(prog.completos, total) : 0
                    const pct = total ? Math.round((feitas / total) * 100) : 0
                    const status = total && feitas >= total ? 'concluidas' : feitas > 0 ? 'andamento' : 'nao'
                    const catItem = (this.categorias || []).find(c => c.idCategoria === t.idCategoria)
                    return {
                        ...t,
                        id: t.idTreinamento,
                        titulo: t.nmTreinamento,
                        autor: t.nmAutor,
                        total,
                        feitas,
                        pct,
                        status,
                        ultimoAcesso: prog?.ultimo || null,
                        cat: {
                            id: t.idCategoria || '_',
                            titulo: catItem?.nmCategoria || 'Sem categoria',
                        },
                    }
                })
            },

            resumo() {
                const l = this.lista
                const comAulas = l.filter(t => t.total)
                return {
                    seguindo: l.length,
                    andamento: l.filter(t => t.status === 'andamento').length,
                    concluidas: l.filter(t => t.status === 'concluidas').length,
                    nao: l.filter(t => t.status === 'nao').length,
                    media: comAulas.length ? Math.round(comAulas.reduce((s, t) => s + t.pct, 0) / comAulas.length) : 0,
                }
            },

            filtros() {
                return [
                    { id: 'todas', label: 'Todas', count: this.resumo.seguindo },
                    { id: 'andamento', label: 'Em andamento', count: this.resumo.andamento },
                    { id: 'nao', label: 'Não iniciadas', count: this.resumo.nao },
                    { id: 'concluidas', label: 'Concluídas', count: this.resumo.concluidas },
                ]
            },

            filtradas() {
                const q = (this.busca || '').trim().toLowerCase()
                let l = this.lista.filter(t => this.filtro === 'todas' || t.status === this.filtro)
                if (q) l = l.filter(t => `${t.titulo} ${t.autor || ''} ${t.cat.titulo}`.toLowerCase().includes(q))
                const ord = {
                    acesso: (a, b) => this.tempo(b.ultimoAcesso) - this.tempo(a.ultimoAcesso),
                    progresso: (a, b) => b.pct - a.pct,
                    nome: (a, b) => (a.titulo || '').localeCompare(b.titulo || '', 'pt-BR'),
                }[this.ordem]
                return [...l].sort(ord)
            },

            grupos() {
                const mapa = new Map()
                for (const t of this.filtradas) {
                    if (!mapa.has(t.cat.id)) mapa.set(t.cat.id, { ...t.cat, trilhas: [] })
                    mapa.get(t.cat.id).trilhas.push(t)
                }
                return [...mapa.values()]
            },

            retomar() {
                if ((this.busca || '').trim() || !['todas', 'andamento'].includes(this.filtro)) return null
                const em = this.lista.filter(t => t.status === 'andamento')
                if (!em.length) return null
                return [...em].sort((a, b) => this.tempo(b.ultimoAcesso) - this.tempo(a.ultimoAcesso))[0]
            },

            vazio() {
                if (this.grupos.length) return null
                if ((this.busca || '').trim()) return ['Nada encontrado', `Nenhuma das suas trilhas corresponde a "${this.busca.trim()}".`]
                return MENSAGENS_VAZIO[this.filtro]
            },
        },

        methods: {
            load() {
                this.getTrilhasClientes()
                this.getCategorias()
                this.getProgressoTrilhas()
            },

            getTrilhasClientes() {
                axios.get(`${urlApi}/SollAcademy/GetTreinamentosSeguidos`, {
                    params: { index: this.currentPage, take: this.pageSize }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.minhasTrilhas = res.data.data.rows.map(r => {
                                const item = r.item
                                item.urlFoto = item.urlFoto || 'img-default-curso.png'
                                return item
                            })
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao carregar trilhas:', err)
                        avisoToast('Erro ao carregar trilhas!', 'warning')
                    })
            },

            getCategorias() {
                axios.get(`${urlApi}/SollAcademy/GetCategorias`)
                    .then(res => {
                        if (res.data.success) {
                            this.categorias = res.data.data.rows.map(r => r.item)
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição:', err)
                        avisoToast('Erro ao carregar categorias!', 'warning')
                    })
            },

            getProgressoTrilhas() {
                axios.get(`${urlApi}/SollAcademy/GetProgressoTreinamentosCliente`)
                    .then(res => {
                        if (res.data.success) {
                            this.progressos = res.data.data
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição:', err)
                        avisoToast('Erro ao carregar progresso!', 'warning')
                    })
            },

            abrirModal(trilha) {
                this.trilhaSelecionada = trilha
            },

            continuar(trilha) {
                this.$router.push({ name: 'SollAcademyAula', query: { idTrilha: trilha.idTreinamento || trilha.id } })
            },

            clicarCard(trilha) {
                this.abrirModal(trilha)
            },

            onDeixouDeSeguir() {
                setTimeout(() => this.load(), 100)
            },

            limparFiltros() {
                this.filtro = 'todas'
                this.busca = ''
            },

            statusInfo(status) {
                return STATUS[status] || STATUS.nao
            },

            rotuloAulas(trilha) {
                return trilha.total ? `${trilha.feitas} de ${trilha.total} aulas · ${trilha.pct}%` : 'Aulas em breve'
            },

            plural(quantidade, singular, pluralTxt) {
                return `${quantidade} ${quantidade === 1 ? singular : pluralTxt}`
            },

            tempo(iso) {
                const n = iso ? new Date(iso).getTime() : 0
                return Number.isNaN(n) ? 0 : n
            },

            tempoDesde(iso) {
                const t = this.tempo(iso)
                if (!t) return ''
                const dias = Math.floor((Date.now() - t) / 86400000)
                if (dias <= 0) return 'Último acesso hoje'
                if (dias === 1) return 'Último acesso ontem'
                if (dias < 30) return `Último acesso há ${dias} dias`
                return `Último acesso em ${new Date(t).toLocaleDateString('pt-BR')}`
            },

            tom(trilha) {
                const tons = [
                    ['#e0e7ff', '#4338ca'],
                    ['#dcfce7', '#15803d'],
                    ['#fef3c7', '#b45309'],
                    ['#fce7f3', '#be185d'],
                    ['#e0f2fe', '#0369a1'],
                ]
                const chave = String(trilha?.id ?? trilha?.titulo ?? '')
                let h = 0
                for (const ch of chave) h = (h * 31 + ch.charCodeAt(0)) >>> 0
                const [bg, fg] = tons[h % tons.length]
                return { '--sa-ph-bg': bg, '--sa-ph-fg': fg }
            },

            semImagem(trilha) {
                const url = trilha?.urlFoto
                if (!url) return true
                return this.imagensComErro.has(url)
            },

            onErroImagem(trilha) {
                if (!trilha?.urlFoto) return
                const s = new Set(this.imagensComErro)
                s.add(trilha.urlFoto)
                this.imagensComErro = s
            },
        },

        mounted() {
            this.load()
        },
    }
</script>


<style scoped>
.tyn-content,
.tyn-main,
.tyn-section {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.sa {
  --sa-azul-escuro: #0b1f4d;
  --sa-primaria: #2563eb;
  --sa-primaria-hover: #1d4ed8;
  --sa-link: #1d4ed8;
  --sa-sucesso: #059669;
  --sa-texto: #0f172a;
  --sa-texto-2: #334155;
  --sa-texto-3: #475569;
  --sa-muted: #64748b;
  --sa-borda: #e2e8f0;
  --sa-fundo: #f4f6fa;
  --sa-gutter: 40px;
  --sa-colunas: 7;

  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--sa-fundo);
  font-family: 'Poppins', system-ui, sans-serif;
  color: var(--sa-texto);
}

.sa svg { width: 18px; height: 18px; flex-shrink: 0; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.sa svg.is-fill { fill: currentColor; stroke: none; }
.sa .sa-icone-sm { width: 14px; height: 14px; }
.sa button, .sa select, .sa input { font: inherit; }
.sa button { color: inherit; }
.sa button:focus-visible, .sa input:focus-visible, .sa select:focus-visible { outline: 2px solid var(--sa-primaria); outline-offset: 2px; }
.sa-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
.sa-muted { color: var(--sa-muted); }
.sa-sm { font-size: 13px; }
.sa-h2 { margin: 0; font-size: 18px; font-weight: 700; }

/* ---------- Botões ---------- */
.sa-btn {
  height: 44px; padding: 0 20px;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  border: 1px solid transparent; border-radius: 10px;
  font-size: 14px; font-weight: 600; white-space: nowrap; cursor: pointer;
  transition: background 0.15s;
}
.sa-btn--alto { height: 48px; padding: 0 22px; border-radius: 12px; }
.sa-btn--primario { background: var(--sa-primaria); color: #fff !important; }
.sa-btn--primario:hover { background: var(--sa-primaria-hover); }
.sa-btn--branco { background: #fff; color: var(--sa-azul-escuro) !important; }
.sa-btn--branco:hover { background: #e2e8f0; }
.sa-btn--contorno { background: #fff; border-color: var(--sa-borda); color: var(--sa-texto-2) !important; }
.sa-btn--contorno:hover { background: #f8fafc; }

.sa-link {
  display: inline-flex; align-items: center; gap: 4px; min-height: 36px; padding: 0;
  border: 0; background: none; color: var(--sa-link) !important;
  font-size: 14px; font-weight: 600; cursor: pointer;
}
.sa-link svg { width: 16px; height: 16px; }

/* ---------- Cabeçalho ---------- */
.sa-hero {
  display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 40px; align-items: center;
  padding: 22px var(--sa-gutter);
  background: var(--sa-azul-escuro); color: #fff;
}
.sa-hero-titulos { display: flex; flex-direction: column; gap: 6px; }
.sa-hero-titulo { margin: 0; font-size: 24px; line-height: 1.3; font-weight: 700; }
.sa-hero-sub { margin: 0; font-size: 14px; line-height: 1.5; color: #cbd5e1; }
.sa-hero-lado { display: flex; align-items: stretch; gap: 12px; }

.sa-stats {
  margin: 0; display: flex; align-items: stretch;
  border-radius: 12px; background: rgba(255, 255, 255, 0.08); border: 1px solid rgba(255, 255, 255, 0.14);
}
.sa-stat { min-width: 96px; padding: 12px 22px; display: flex; flex-direction: column; gap: 2px; }
.sa-stat + .sa-stat { border-left: 1px solid rgba(255, 255, 255, 0.14); }
.sa-stat dt { font-size: 12px; color: #cbd5e1; }
.sa-stat dd { margin: 0; font-size: 22px; font-weight: 700; }
.sa-stat--largo { min-width: 180px; gap: 6px; }
.sa-stat-media { display: flex; align-items: center; gap: 10px; }
.sa-stat-barra { flex-grow: 1; height: 6px; border-radius: 999px; background: rgba(255, 255, 255, 0.18); overflow: hidden; }
.sa-stat-barra span { display: block; height: 100%; background: #34d399; border-radius: 999px; }

/* ---------- Conteúdo ---------- */
.sa-main { flex-grow: 1; display: flex; flex-direction: column; gap: 24px; padding: 24px var(--sa-gutter) 48px; }

.sa-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; }
.sa-segmentos { display: flex; gap: 4px; padding: 4px; background: #fff; border: 1px solid var(--sa-borda); border-radius: 12px; }
.sa-segmento {
  height: 36px; padding: 0 14px;
  display: inline-flex; align-items: center; gap: 8px;
  border: 0; border-radius: 8px; background: transparent; color: var(--sa-texto-3) !important;
  font-size: 13px; font-weight: 600; white-space: nowrap; cursor: pointer;
}
.sa-segmento:hover { background: #f1f5f9; }
.sa-segmento.is-ativo { background: var(--sa-azul-escuro); color: #fff !important; }
.sa-segmento-num { font-size: 11px; padding: 1px 7px; border-radius: 999px; background: #f1f5f9; color: var(--sa-texto-3); }
.sa-segmento.is-ativo .sa-segmento-num { background: rgba(255, 255, 255, 0.18); color: #fff; }

.sa-toolbar-direita { display: flex; align-items: center; gap: 8px; }
.sa-busca { position: relative; display: flex; align-items: center; }
.sa-busca svg { position: absolute; left: 12px; width: 16px; height: 16px; color: var(--sa-muted); pointer-events: none; }
.sa-busca input {
  width: 300px; height: 44px; box-sizing: border-box; padding: 0 12px 0 36px;
  border: 1px solid var(--sa-borda); border-radius: 12px; background: #fff; font-size: 13px; color: var(--sa-texto);
}
.sa-ordem {
  height: 44px; box-sizing: border-box; padding: 0 12px;
  display: flex; align-items: center; gap: 8px;
  border: 1px solid var(--sa-borda); border-radius: 12px; background: #fff;
  font-size: 13px; color: var(--sa-muted);
}
.sa-ordem select { border: 0; background: transparent; font-size: 13px; font-weight: 600; color: var(--sa-texto); cursor: pointer; }

/* Painel */
.sa-painel {
  display: flex; flex-direction: column; gap: 18px;
  padding: 20px 24px 24px;
  background: #fff; border: 1px solid var(--sa-borda); border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.sa-painel-cabecalho {
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  padding-bottom: 14px; border-bottom: 1px solid #eef2f7;
}
.sa-painel-titulos { display: flex; align-items: baseline; gap: 12px; min-width: 0; }

/* Continue de onde parou */
.sa-retome {
  display: grid; grid-template-columns: 320px minmax(0, 1fr) auto; gap: 28px; align-items: center;
  width: 100%; padding: 0; border: 0; background: none; text-align: left; cursor: pointer;
}
.sa-retome:hover .sa-retome-titulo { color: var(--sa-link); }
.sa-retome-capa {
  position: relative; aspect-ratio: 16 / 9; overflow: hidden; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  background: var(--sa-ph-bg, #1e293b);
}
.sa-retome-capa img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.sa-retome-play {
  position: relative; width: 52px; height: 52px; border-radius: 999px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255, 255, 255, 0.95); color: var(--sa-texto);
}
.sa-retome-play svg { width: 20px; height: 20px; }
.sa-retome-texto { display: flex; flex-direction: column; gap: 10px; min-width: 0; }
.sa-retome-cat { font-size: 12px; font-weight: 600; color: var(--sa-muted); }
.sa-retome-titulo { font-size: 22px; line-height: 1.3; font-weight: 700; color: var(--sa-texto); transition: color 0.15s; }
.sa-retome-proxima { font-size: 14px; color: var(--sa-texto-3); }
.sa-retome-proxima strong { color: var(--sa-texto); font-weight: 600; }
.sa-retome-progresso { display: flex; align-items: center; gap: 12px; max-width: 520px; font-size: 13px; color: var(--sa-texto-3); white-space: nowrap; }

.sa-barra { display: block; flex-grow: 1; height: 5px; border-radius: 999px; background: var(--sa-borda); overflow: hidden; }
.sa-barra--lg { height: 8px; }
.sa-barra > span { display: block; height: 100%; background: var(--sa-sucesso); border-radius: 999px; }

/* Grade de cards (aqui pode quebrar linha: é a lista completa do usuário) */
.sa-grade { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(var(--sa-colunas), minmax(0, 1fr)); gap: 16px; }
.sa-grade > li { display: flex; }

.sa-card {
  width: 100%; box-sizing: border-box; padding: 0;
  display: flex; flex-direction: column;
  background: #fff; border: 1px solid var(--sa-borda); border-radius: 12px; overflow: hidden;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
  text-align: left; color: var(--sa-texto) !important; cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
}
.sa-card:hover { transform: translateY(-2px); border-color: #c7d2fe; box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08); }

.sa-capa {
  position: relative; aspect-ratio: 16 / 9; flex-shrink: 0; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  background: var(--sa-ph-bg, #e2e8f0); color: var(--sa-ph-fg, #475569);
}
.sa-capa img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.sa-capa-icone { width: 32px !important; height: 32px !important; stroke-width: 1.6 !important; }

.sa-status { position: absolute; left: 8px; top: 8px; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 999px; }
.sa-status.is-nao { background: rgba(255, 255, 255, 0.92); color: var(--sa-texto-2); }
.sa-status.is-andamento { background: var(--sa-primaria); color: #fff; }
.sa-status.is-concluida { background: var(--sa-sucesso); color: #fff; }

.sa-card-corpo { flex-grow: 1; display: flex; flex-direction: column; gap: 4px; padding: 14px 16px 16px; min-width: 0; }
.sa-card-titulo {
  font-size: 14px; font-weight: 600; line-height: 1.4;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.sa-card-rodape { margin-top: auto; padding-top: 12px; display: flex; flex-direction: column; gap: 6px; }
.sa-card-linha { display: flex; justify-content: space-between; gap: 8px; font-size: 12px; color: var(--sa-muted); }
.sa-card-cta { font-weight: 600; color: var(--sa-link); }
.sa-card-cta.is-acao { cursor: pointer; text-decoration: underline; text-underline-offset: 2px; }
.sa-card-cta.is-inativo { color: #94a3b8; }

/* Vazio */
.sa-vazio { align-items: center; padding: 56px 24px; text-align: center; gap: 10px; font-size: 13px; line-height: 1.55; color: var(--sa-muted); }
.sa-vazio strong { font-size: 15px; color: var(--sa-texto-2); }
.sa-vazio > span:not(.sa-vazio-icone) { max-width: 360px; }
.sa-vazio .sa-btn { margin-top: 6px; height: 40px; }
.sa-vazio-icone {
  width: 52px; height: 52px; border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  background: #f1f5f9; color: var(--sa-muted);
}
.sa-vazio-icone svg { width: 24px; height: 24px; stroke-width: 1.8; }

/* ---------- Rodapé ---------- */
.sa-rodape { margin-top: auto; display: flex; flex-direction: column; gap: 20px; padding: 28px var(--sa-gutter) 22px; background: var(--sa-azul-escuro); color: #fff; }
.sa-rodape-cta { display: flex; align-items: center; justify-content: space-between; gap: 32px; }
.sa-rodape-texto { display: flex; flex-direction: column; gap: 6px; }
.sa-rodape-texto strong { font-size: 18px; font-weight: 700; }
.sa-rodape-texto span { font-size: 14px; color: #cbd5e1; }
.sa-rodape-linha {
  display: flex; justify-content: space-between; gap: 16px;
  padding-top: 20px; border-top: 1px solid rgba(255, 255, 255, 0.14);
  font-size: 12px; color: #94a3b8;
}

/* ---------- Responsivo ---------- */
@media (max-width: 1700px) { .sa { --sa-colunas: 6; } }
@media (max-width: 1440px) { .sa { --sa-colunas: 5; --sa-gutter: 32px; } }
@media (max-width: 1280px) {
  .sa { --sa-colunas: 4; }
  .sa-hero { grid-template-columns: minmax(0, 1fr); gap: 16px; }
  .sa-retome { grid-template-columns: 240px minmax(0, 1fr); }
  .sa-retome > .sa-btn { grid-column: 1 / -1; justify-self: start; }
}
@media (max-width: 1024px) {
  .sa { --sa-colunas: 3; }
  .sa-hero-lado { flex-direction: column; align-items: stretch; }
  .sa-stats { flex-wrap: wrap; }
}
@media (max-width: 760px) {
  .sa { --sa-colunas: 2; --sa-gutter: 16px; }
  .sa-toolbar-direita, .sa-busca, .sa-busca input { width: 100%; }
  .sa-toolbar-direita { flex-direction: column; align-items: stretch; }
  .sa-segmentos { width: 100%; overflow-x: auto; scrollbar-width: none; }
  .sa-segmentos::-webkit-scrollbar { display: none; }
  .sa-retome { grid-template-columns: minmax(0, 1fr); gap: 16px; }
  .sa-retome-titulo { font-size: 18px; }
  .sa-painel { padding: 16px; }
  .sa-rodape-cta { flex-direction: column; align-items: flex-start; }
}
@media (max-width: 480px) { .sa { --sa-colunas: 1; } }

.sa a { text-decoration: none; color: inherit; }
.sa-hero-titulo {
  color: #fff !important;
  background: none;
  -webkit-text-fill-color: #fff;
}
.sa-status, .sa-retome-play { z-index: 1; }
.sa-capa img, .sa-retome-capa img { z-index: 0; }

[data-bs-theme="dark"] .sa {
  --sa-texto: #f1f5f9;
  --sa-texto-2: #cbd5e1;
  --sa-texto-3: #94a3b8;
  --sa-muted: #94a3b8;
  --sa-borda: rgba(148, 163, 184, 0.22);
  --sa-fundo: #0b1120;
  --sa-link: #93c5fd;
}
[data-bs-theme="dark"] .sa-segmentos,
[data-bs-theme="dark"] .sa-busca input,
[data-bs-theme="dark"] .sa-ordem,
[data-bs-theme="dark"] .sa-painel,
[data-bs-theme="dark"] .sa-card,
[data-bs-theme="dark"] .sa-btn--contorno { background: #1e293b; color: #f1f5f9; }
[data-bs-theme="dark"] .sa-painel-cabecalho { border-bottom-color: rgba(148, 163, 184, 0.14); }
[data-bs-theme="dark"] .sa-segmento:hover { background: rgba(148, 163, 184, 0.12); }
[data-bs-theme="dark"] .sa-segmento-num { background: rgba(148, 163, 184, 0.16); color: #e2e8f0; }
</style>
